<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Accesso negato</h1>
      </div>
    </header>

    <section class="editor-panel denied-panel">
      <div class="lock-wrap" aria-hidden="true">
        <div class="lock"></div>
      </div>
      <h2>L'accesso a questa pagina è limitato</h2>
      <p class="editor-lead">Effettua il login se hai i permessi per accedere.</p>
      <a class="editor-save" routerLink="/login">Vai al login</a>
    </section>
  </div>
</div>
